export default __webpack_public_path__ + "static/media/64t.544263e7.jpg";